<template>
    <div class="main-login">
        <v-row class="justify-center align-center no-gutters">
            <v-col cols="12" lg="4" md="5" sm="6" xl="3">
                <div class="form-login">
                    <v-btn
                        class="btn-back"
                        elevation="0"
                        text
                        @click="$router.push({ name: 'login' })"
                    >
                        <v-icon size="18">mdi-arrow-left</v-icon>
                        {{ $t("global.back") }}
                    </v-btn>
                    <v-img src="images/logo.svg" width="166"/>

                    <h1 class="mb-6">{{ $t("login.forgot_password") }}</h1>

                    <v-form v-model="valid">
                        <v-text-field
                            v-model="email"
                            :label="$t('login.identifier')"
                            :rules="login_rules"
                            dense
                            outlined
                            type="text"
                        ></v-text-field>

                        <div class="d-flex">
                            <v-btn :disabled="!valid" :loading="loading" block
                                   color="primary"
                                   elevation="0"
                                   @click="callReset">
                                {{ $t("global.validate") }}
                            </v-btn>
                        </div>
                    </v-form>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { showSnackbar } from "../functions";

export default {
    name: "ForgotPassword",
    data() {
        return {
            login_rules: [(v) => !!v || this.$t("login.required_login")],
            valid: false,
            email: null,
            loading: false
        };
    },
    mounted() {
        this.email = this.$route.query.email || null
    },
    methods: {
        async callReset() {
            try {
                this.loading = true
                await this.$api.auth.sendResetLink({
                    email: this.email
                })
                showSnackbar('success', this.$t('login.reset_link_sent'))
            } catch (e) {
            } finally {
                this.loading = false
            }
        }
    }
};
</script>
